"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CODE_TO_SYMBOL = exports.CURRENCY_DISPLAY_HARDCODE = exports.SYMBOL_HARD_CODE_CONFIG = exports.HARD_CODE_CONFIG = void 0;
var HARD_CODE_CONFIG = [{
  code: 'TWD',
  digit: 0
}, // 新台币
{
  code: 'HUF',
  digit: 0
}, // 匈牙利福林
{
  code: 'RUB',
  digit: 0
}, // 俄罗斯卢布
{
  code: 'CVE',
  digit: 0
}, // 佛得角埃斯库多
{
  code: 'AFN',
  digit: 2
}, // 阿富汗尼
{
  code: 'ALL',
  digit: 2
}, // 阿尔巴尼亚列克
{
  code: 'IRR',
  digit: 2
}, // 伊朗里亚尔
{
  code: 'KPW',
  digit: 2
}, // 朝鲜圆
{
  code: 'LAK',
  digit: 2
}, // 老挝基普
{
  code: 'LBP',
  digit: 2
}, // 黎巴嫩镑
{
  code: 'MMK',
  digit: 2
}, // 缅元
{
  code: 'RSD',
  digit: 2
}, // 塞尔维亚第纳尔
{
  code: 'SLL',
  digit: 2
}, // 塞拉利昂利昂
{
  code: 'SOS',
  digit: 2
}, // 索马里先令
{
  code: 'SYP',
  digit: 2
}, // 叙利亚镑
{
  code: 'UYU',
  digit: 2
}, // 乌拉圭比索
{
  code: 'YER',
  digit: 2
}, // 也门里亚尔
{
  code: 'KWD',
  digit: 2
}, // 科威特第纳尔
{
  code: 'OMR',
  digit: 2
}, // 阿曼里亚尔
{
  code: 'BHD',
  digit: 2
}, // 巴林第纳尔
{
  code: 'IDR',
  digit: 0
} // 印尼盾
];
/**
 * 单位语言环境hard code
 * 由于产品认为AUD 在英文环境下应该格式化为AU$ 而不是A$
 * 解决方案就是当为此种货币切在此种语言环境下 就映射到符合产品要求的语言环境
 * 所以这里对此种场景进行hardcode映射解决此问题
 * 后续有更多需要hardcode的本地化可以在这里map添加
 */

exports.HARD_CODE_CONFIG = HARD_CODE_CONFIG;
var SYMBOL_HARD_CODE_CONFIG = {
  AUD: {
    // key 为源语言
    // value 为目标语言
    en: 'zh-hans-cn'
  },
  TWD: {
    // key 为源语言
    // value 为目标语言
    'zh-hant-tw': 'zh-hant-hk'
  },
  MXN: {
    // key 为源语言
    // value 为目标语言
    es: 'en'
  },
  CLP: {
    // key 为源语言
    // value 为目标语言
    es: 'es-CL'
  }
};
exports.SYMBOL_HARD_CODE_CONFIG = SYMBOL_HARD_CODE_CONFIG;
var CURRENCY_DISPLAY_HARDCODE = {
  PHP: {
    currencyDisplay: 'code'
  }
};
exports.CURRENCY_DISPLAY_HARDCODE = CURRENCY_DISPLAY_HARDCODE;
var CODE_TO_SYMBOL = {
  AED: 'د.إ',
  AFN: '؋',
  ALL: 'L',
  AMD: '֏',
  ANG: 'ƒ',
  AOA: 'Kz',
  ARS: '$',
  AUD: '$',
  AWG: 'ƒ',
  AZN: '₼',
  BAM: 'KM',
  BBD: '$',
  BDT: '৳',
  BGN: 'лв',
  BHD: '.د.ب',
  BIF: 'FBu',
  BMD: '$',
  BND: '$',
  BOB: '$b',
  BOV: 'BOV',
  BRL: 'R$',
  BSD: '$',
  BTC: '₿',
  BTN: 'Nu.',
  BWP: 'P',
  BYN: 'Br',
  BYR: 'Br',
  BZD: 'BZ$',
  CAD: '$',
  CDF: 'FC',
  CHE: 'CHE',
  CHF: 'CHF',
  CHW: 'CHW',
  CLF: 'CLF',
  CLP: '$',
  CNY: '¥',
  COP: '$',
  COU: 'COU',
  CRC: '₡',
  CUC: '$',
  CUP: '₱',
  CVE: '$',
  CZK: 'Kč',
  DJF: 'Fdj',
  DKK: 'kr',
  DOP: 'RD$',
  DZD: 'دج',
  EEK: 'kr',
  EGP: '£',
  ERN: 'Nfk',
  ETB: 'Br',
  ETH: 'Ξ',
  EUR: '€',
  FJD: '$',
  FKP: '£',
  GBP: '£',
  GEL: '₾',
  GGP: '£',
  GHC: '₵',
  GHS: 'GH₵',
  GIP: '£',
  GMD: 'D',
  GNF: 'FG',
  GTQ: 'Q',
  GYD: '$',
  HKD: '$',
  HNL: 'L',
  HRK: 'kn',
  HTG: 'G',
  HUF: 'Ft',
  IDR: 'Rp',
  ILS: '₪',
  IMP: '£',
  INR: '₹',
  IQD: 'ع.د',
  IRR: '﷼',
  ISK: 'kr',
  JEP: '£',
  JMD: 'J$',
  JOD: 'JD',
  JPY: '¥',
  KES: 'KSh',
  KGS: 'лв',
  KHR: '៛',
  KMF: 'CF',
  KPW: '₩',
  KRW: '₩',
  KWD: 'KD',
  KYD: '$',
  KZT: '₸',
  LAK: '₭',
  LBP: '£',
  LKR: '₨',
  LRD: '$',
  LSL: 'M',
  LTC: 'Ł',
  LTL: 'Lt',
  LVL: 'Ls',
  LYD: 'LD',
  MAD: 'MAD',
  MDL: 'lei',
  MGA: 'Ar',
  MKD: 'ден',
  MMK: 'K',
  MNT: '₮',
  MOP: 'MOP$',
  MRO: 'UM',
  MRU: 'UM',
  MUR: '₨',
  MVR: 'Rf',
  MWK: 'MK',
  MXN: '$',
  MXV: 'MXV',
  MYR: 'RM',
  MZN: 'MT',
  NAD: '$',
  NGN: '₦',
  NIO: 'C$',
  NOK: 'kr',
  NPR: '₨',
  NZD: '$',
  OMR: '﷼',
  PAB: 'B/.',
  PEN: 'S/.',
  PGK: 'K',
  PHP: '₱',
  PKR: '₨',
  PLN: 'zł',
  PYG: 'Gs',
  QAR: '﷼',
  RMB: '￥',
  RON: 'lei',
  RSD: 'Дин.',
  RUB: '₽',
  RWF: 'R₣',
  SAR: '﷼',
  SBD: '$',
  SCR: '₨',
  SDG: 'ج.س.',
  SEK: 'kr',
  SGD: 'S$',
  SHP: '£',
  SLL: 'Le',
  SOS: 'S',
  SRD: '$',
  SSP: '£',
  STD: 'Db',
  STN: 'Db',
  SVC: '$',
  SYP: '£',
  SZL: 'E',
  THB: '฿',
  TJS: 'SM',
  TMT: 'T',
  TND: 'د.ت',
  TOP: 'T$',
  TRL: '₤',
  TRY: '₺',
  TTD: 'TT$',
  TVD: '$',
  TWD: 'NT$',
  TZS: 'TSh',
  UAH: '₴',
  UGX: 'USh',
  USD: '$',
  UYI: 'UYI',
  UYU: '$U',
  UYW: 'UYW',
  UZS: 'лв',
  VEF: 'Bs',
  VES: 'Bs.S',
  VND: '₫',
  VUV: 'VT',
  WST: 'WS$',
  XAF: 'FCFA',
  XBT: 'Ƀ',
  XCD: '$',
  XOF: 'CFA',
  XPF: '₣',
  XSU: 'Sucre',
  XUA: 'XUA',
  YER: '﷼',
  ZAR: 'R',
  ZMW: 'ZK',
  ZWD: 'Z$',
  ZWL: '$'
};
exports.CODE_TO_SYMBOL = CODE_TO_SYMBOL;